//import data from "./articles/demo";
//import data from "./articles/miljopartiet";
//import data from "./articles/brexit";
//import data from "./articles/hedersmord";
//import data from "./articles/test";
//import data from "./articles/hyrestestet";
//import data from "./articles/zika";
//import data from "./articles/zikatimeline";
import data from "./articles/flight";
export default data;




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/index.js
 **/